<div class="pt-3 mb-5">
  <div
    id="pricing-plan-grid"
    [ngClass]="{ 'with-unlimited': canAccessUnlimitedPlan }"
  >
    <div
      id="plan-1-title"
      class="u_clickable top-grid-row pb-2"
      [ngClass]="{
        selected: isBasicPlan && !isUnlimitedPlan,
        disabled: planType === 'basic',
      }"
      (click)="selectBasic()"
    >
      @if (canAccessUnlimitedPlan) {
        <div class="text-center u_position-relative px-xl-4">
          @if (planType === 'basic') {
            <rv-badge
              class="current-plan-pill"
              appearance="solid"
              color="gray"
              text="Current Plan"
            />
          }
          <h2>Basic</h2>
          <p>A few displays to get started</p>
        </div>
      } @else {
        <div class="text-center px-xl-4">
          @if (planType === 'basic') {
            <rv-badge
              class="current-plan-pill"
              appearance="solid"
              color="gray"
              text="Current Plan"
            />
          }
          <h2>Basic</h2>
          <p>Getting started with a few displays</p>
        </div>
      }
    </div>
    <div
      id="plan-2-title"
      class="u_clickable top-grid-row pb-2"
      [ngClass]="{
        selected: isAdvancedPlan && !isUnlimitedPlan,
        disabled: planType === 'advanced',
      }"
      (click)="selectAdvanced()"
    >
      @if (canAccessUnlimitedPlan) {
        <div class="text-center u_position-relative px-xl-4">
          @if (planType === 'advanced') {
            <rv-badge
              class="current-plan-pill"
              appearance="solid"
              color="gray"
              text="Current Plan"
            />
          }
          <h2>Advanced</h2>
          <p>
            Displays throughout the school, in the hallways and common areas
          </p>
        </div>
      } @else {
        <div class="text-center px-xl-4">
          @if (planType === 'advanced') {
            <rv-badge
              class="current-plan-pill"
              appearance="solid"
              color="gray"
              text="Current Plan"
            />
          }
          <h2>Advanced</h2>
          <p>Growing display network and content management needs</p>
        </div>
      }
    </div>
    <div
      id="plan-3-title"
      class="u_clickable top-grid-row pb-2"
      [ngClass]="{
        selected: isUnlimitedPlan || isEnterprisePlan,
        disabled: planType === 'enterprise' && !canAccessUnlimitedPlan,
      }"
      (click)="selectEnterpriseOrUnlimited()"
    >
      <div class="text-center u_position-relative px-xl-4">
        @if (planType === 'enterprise') {
          <rv-badge
            class="current-plan-pill"
            appearance="solid"
            color="gray"
            text="Current Plan"
          />
        }
        <h2>Enterprise</h2>
        <p>
          Display network across multiple locations{{
            canAccessUnlimitedPlan ? ',' : ' and'
          }}
          network management tools{{
            canAccessUnlimitedPlan
              ? ' and a fixed price per school for unlimited displays'
              : ''
          }}.
        </p>
      </div>
    </div>

    <div
      id="plan-1-frequency"
      class="py-4 u_align-middle u_clickable"
      [ngClass]="{
        selected: isBasicPlan && !isUnlimitedPlan,
        disabled: planType === 'basic',
      }"
      (click)="selectBasic()"
    >
      @if (!subscriptionId) {
        <div class="text-center">
          <div class="btn-group btn-group-justified btn-group-period mb-0">
            <button
              type="button"
              class="btn w-50"
              [ngClass]="{
                'btn-toggle-blue-off': !periodMonthly,
                'btn-toggle-blue-on': periodMonthly,
              }"
              (click)="updatePeriodMonthly(true)"
            >
              Monthly
              <streamline-icon
                aria-label="Monthly selected"
                name="checkmark"
                [shown]="periodMonthly"
              ></streamline-icon>
            </button>
            <button
              type="button"
              class="btn w-50"
              [ngClass]="{
                'btn-toggle-blue-off': periodMonthly,
                'btn-toggle-blue-on': !periodMonthly,
              }"
              (click)="updatePeriodMonthly(false)"
            >
              Annually
              <streamline-icon
                ariaLabel="Annually selected"
                name="checkmark"
                [shown]="!periodMonthly"
              ></streamline-icon>
            </button>
          </div>
        </div>
      } @else {
        <div class="text-center">
          <div>Paid Annually</div>
        </div>
      }
    </div>
    <div
      id="plan-2-frequency"
      class="py-4 u_align-middle u_clickable"
      [ngClass]="{
        selected: isAdvancedPlan && !isUnlimitedPlan,
        disabled: planType === 'advanced',
      }"
      (click)="selectAdvanced()"
    >
      <div class="text-center">
        <div>Paid Annually</div>
      </div>
    </div>
    <div
      id="plan-3-frequency"
      class="py-4 u_clickable u_align-middle px-0 px-lg-2 px-xl-4"
      [ngClass]="{
        selected: isUnlimitedPlan || isEnterprisePlan,
        disabled: planType === 'enterprise' && !canAccessUnlimitedPlan,
      }"
      (click)="selectEnterpriseOrUnlimited()"
    >
      <div
        class="flex-row text-center"
        [ngClass]="{ 'u_align-middle': !canAccessUnlimitedPlan }"
      >
        @if (canAccessUnlimitedPlan) {
          <div class="flex-50">
            <div class="tw-px-4 text-xl font-weight-bold">
              Unlimited Displays
            </div>
            <div class="tw-py-4">Paid Annually</div>
          </div>
        }
        <div [ngClass]="{ 'flex-50': canAccessUnlimitedPlan }">
          <div class="px-4 text-xl font-weight-bold">Per Display</div>
          <div class="tw-py-4">Paid Annually</div>
        </div>
      </div>
    </div>

    <div
      id="plan-1-price"
      class="u_align-middle text-center u_clickable tw-pb-8"
      [ngClass]="{
        selected: isBasicPlan && !isUnlimitedPlan,
        disabled: planType === 'basic',
      }"
      (click)="selectBasic()"
    >
      <div class="px-4 tw-text-4xl tw-font-bold">
        {{ basicPricePerDisplay | currency: 'USD' : 'symbol' : '1.0-0' }}
      </div>
      <div class="tw-py-2">
        per display<wbr /> per&nbsp;{{ periodMonthly ? 'month' : 'year' }}
      </div>
    </div>
    <div
      id="plan-2-price"
      class="u_align-middle text-center u_clickable tw-pb-8"
      [ngClass]="{
        selected: isAdvancedPlan && !isUnlimitedPlan,
        disabled: planType === 'advanced',
      }"
      (click)="selectAdvanced()"
    >
      <div class="px-4 tw-text-4xl tw-font-bold">
        {{ advancedPricePerDisplay | currency: 'USD' : 'symbol' : '1.0-0' }}
      </div>
      <div class="tw-py-2">per display<wbr /> per&nbsp;year</div>
    </div>
    <div
      id="plan-3-price"
      class="flex-row px-0 px-lg-2 px-xl-4"
      [ngClass]="{
        selected: isUnlimitedPlan || isEnterprisePlan,
        disabled: planType === 'enterprise' && !canAccessUnlimitedPlan,
        'u_align-middle': !canAccessUnlimitedPlan,
      }"
    >
      @if (canAccessUnlimitedPlan) {
        <div
          class="flex-50 u_align-middle text-center u_clickable tw-pb-8"
          (click)="selectEnterpriseOrUnlimited()"
        >
          <div class="tw-text-4xl tw-font-bold">
            {{ unlimitedPrice | currency: 'USD' : 'symbol' : '1.0-0' }}
          </div>
          <div class="tw-py-2">per school<wbr /> per&nbsp;year</div>
        </div>
      }
      <div
        [ngClass]="{ 'flex-50': canAccessUnlimitedPlan }"
        class="u_align-middle text-center u_clickable tw-pb-8"
        (click)="selectEnterpriseOrUnlimited()"
      >
        <div class="px-4 tw-text-4xl tw-font-bold">
          {{ enterprisePricePerDisplay | currency: 'USD' : 'symbol' : '1.0-0' }}
        </div>
        <div class="tw-py-2">per display<wbr /> per&nbsp;year</div>
      </div>
    </div>
    <div
      id="plan-1-select"
      class="py-4 text-center border-top border-bottom u_nowrap u_clickable"
      [ngClass]="{
        selected: isBasicPlan && !isUnlimitedPlan,
        disabled: planType === 'basic' || allowMultiple,
      }"
      (click)="selectBasic()"
    >
      <div>
        <mat-checkbox
          name="selectBasic"
          id="selectBasic"
          [disabled]="planType === 'basic' || allowMultiple"
          [ngModel]="isBasicPlan && !isUnlimitedPlan"
        ></mat-checkbox>
        <label class="text-blue u_clickable">Select this plan</label>
      </div>
      <div [shown]="!planType && isBasicPlan">
        <div class="pt-3 px-5 plan-select__quantity">
          <rv-quantity
            name="displayCountBasic"
            [(ngModel)]="displayCount"
            [min]="1"
            [required]="true"
            ariaLabel="Basic display licenses"
          ></rv-quantity>
        </div>
        <div class="pt-3">Basic Licenses</div>
      </div>
    </div>
    <div
      id="plan-2-select"
      class="py-4 text-center border-top border-bottom u_nowrap u_clickable"
      [ngClass]="{
        selected: isAdvancedPlan && !isUnlimitedPlan,
        disabled: planType === 'advanced' || allowMultiple,
      }"
      (click)="selectAdvanced()"
    >
      <div>
        <mat-checkbox
          name="selectAdvanced"
          id="selectAdvanced"
          [disabled]="planType === 'advanced'"
          [ngModel]="isAdvancedPlan && !isUnlimitedPlan"
        ></mat-checkbox>
        <label class="text-blue u_clickable">Select this plan</label>
      </div>
      <div [shown]="!planType && isAdvancedPlan">
        <div class="pt-3 px-5 plan-select__quantity">
          <rv-quantity
            name="displayCountAdvanced"
            [(ngModel)]="displayCount"
            [min]="1"
            [required]="true"
            ariaLabel="Advanced display licenses"
          ></rv-quantity>
        </div>
        <div class="pt-3">Advanced Licenses</div>
      </div>
    </div>
    <div
      id="plan-3-select"
      class="flex-row justify-center align-start py-4 text-center border-top border-bottom u_nowrap u_clickable px-0 px-md-2 px-xl-4"
      [ngClass]="{ selected: isUnlimitedPlan || isEnterprisePlan }"
    >
      @if (canAccessUnlimitedPlan) {
        <div class="flex-50" [ngClass]="{ disabled: planType === 'unlimited' }">
          <div (click)="selectUnlimited()">
            <mat-checkbox
              name="selectUnlimited"
              id="selectUnlimited"
              [disabled]="planType === 'unlimited'"
              [ngModel]="isUnlimitedPlan"
            ></mat-checkbox>
            <label class="text-blue u_clickable">Select this plan</label>
          </div>
          <div [shown]="isUnlimitedPlan && allowMultiple">
            <div class="pt-3 px-2 px-lg-5 plan-select__quantity">
              <rv-quantity
                name="unlimitedCount"
                [(ngModel)]="unlimitedCount"
                [min]="1"
                [required]="true"
                ariaLabel="Unlimited licenses"
              ></rv-quantity>
            </div>
            <div class="pt-3">Unlimited Licenses</div>
          </div>
        </div>
      }
      <div
        [ngClass]="{
          'flex-50': canAccessUnlimitedPlan,
          disabled: planType === 'enterprise',
        }"
      >
        <div (click)="selectEnterprise()">
          <mat-checkbox
            name="selectEnterprise"
            id="selectEnterprise"
            [disabled]="planType === 'enterprise'"
            [ngModel]="isEnterprisePlan"
          ></mat-checkbox>
          <label class="text-blue u_clickable">Select this plan</label>
        </div>
        <div [shown]="!planType && isEnterprisePlan">
          <div class="pt-3 px-2 px-lg-5 plan-select__quantity">
            <rv-quantity
              name="displayCountEnterprise"
              [(ngModel)]="displayCount"
              [min]="1"
              [required]="true"
              ariaLabel="Enterprise display licenses"
            ></rv-quantity>
          </div>
          <div class="pt-3">Enterprise Licenses</div>
        </div>
      </div>
    </div>
    <div
      id="plan-1-features"
      class="feature-list bottom-grid-row"
      [ngClass]="{ selected: isBasicPlan && !isUnlimitedPlan }"
    >
      <ul>
        <li>
          <streamline-icon
            aria-hidden="true"
            name="checkmark"
            class="checkmark"
          ></streamline-icon>
          500+ Professionally Designed
          <span class="u_nowrap"
            >Templates
            <streamline-icon
              ariaLabel="More information"
              name="help"
              class="help"
              [outsideClick]="true"
              [popover]="'No design experience required! Customize professionally designed templates for any use such as events, weather, sports, and many more.'"
            >
            </streamline-icon
          ></span>
        </li>
        <li>
          <streamline-icon
            aria-hidden="true"
            name="checkmark"
            class="checkmark"
          ></streamline-icon>
          New Templates Added
          <span class="u_nowrap"
            >Weekly
            <streamline-icon
              ariaLabel="More information"
              name="help"
              class="help"
              [outsideClick]="true"
              [popover]="'New templates added based on recommendations and suggestions of customers like yourself.'"
            >
            </streamline-icon
          ></span>
        </li>
        <li>
          <streamline-icon
            aria-hidden="true"
            name="checkmark"
            class="checkmark"
          ></streamline-icon>
          {{
            canAccessUnlimitedPlan
              ? 'School Specific Content'
              : 'Special Content'
          }}
          (Random Act of Kindness, Good News Network, &amp;
          <span class="u_nowrap"
            >more)
            <streamline-icon
              ariaLabel="More information"
              name="help"
              class="help"
              [outsideClick]="true"
              popover="Templates with content you can trust from reputable known partners like Random Acts of Kindness CASEL.org, and more to help promote learning and positive {{
                canAccessUnlimitedPlan ? 'school' : ''
              }} culture."
            >
            </streamline-icon
          ></span>
        </li>
        <li>
          <streamline-icon
            aria-hidden="true"
            name="checkmark"
            class="checkmark"
          ></streamline-icon>
          Runs On Any Device Any
          <span class="u_nowrap"
            >OS
            <streamline-icon
              ariaLabel="More information"
              name="help"
              class="help"
              [outsideClick]="true"
              [popover]="'Rise Vision runs on a wide range of digital signage media players, wireless presentation systems, and interactive flat panels to fit your needs and budget.'"
            >
            </streamline-icon
          ></span>
        </li>
        <li>
          <streamline-icon
            aria-hidden="true"
            name="checkmark"
            class="checkmark"
          ></streamline-icon>
          Unlimited
          <span class="u_nowrap"
            >Users
            <streamline-icon
              ariaLabel="More information"
              name="help"
              class="help"
              [outsideClick]="true"
              [popover]="'Create content collaboratively with any number of users in your account.'"
            >
            </streamline-icon
          ></span>
        </li>
        <li>
          <streamline-icon
            aria-hidden="true"
            name="checkmark"
            class="checkmark"
          ></streamline-icon>
          Offline
          <span class="u_nowrap"
            >Play
            <streamline-icon
              ariaLabel="More information"
              name="help"
              class="help"
              [outsideClick]="true"
              [popover]="'Stores content locally so that your display is always running regardless of connection status.'"
            >
            </streamline-icon
          ></span>
        </li>
        <li>
          <streamline-icon
            aria-hidden="true"
            name="checkmark"
            class="checkmark"
          ></streamline-icon>
          Unlimited Content Storage (photos, videos,
          <span class="u_nowrap"
            >presentations)
            <streamline-icon
              ariaLabel="More information"
              name="help"
              class="help"
              [outsideClick]="true"
              [popover]="'Save all your photos, videos and presentations in Rise Vision with unlimited storage.'"
            >
            </streamline-icon
          ></span>
        </li>
        <li>
          <streamline-icon
            aria-hidden="true"
            name="checkmark"
            class="checkmark"
          ></streamline-icon>
          Content Integrations (Google Slides, YouTube, PowerPoint, Outlook
          Calendar, Weather & many
          <span class="u_nowrap"
            >more)
            <streamline-icon
              ariaLabel="More information"
              name="help"
              class="help"
              [outsideClick]="true"
              [popover]="'Automatically pull content from the services you already know and love.'"
            >
            </streamline-icon
          ></span>
        </li>
        <li>
          <streamline-icon
            aria-hidden="true"
            name="checkmark"
            class="checkmark"
          ></streamline-icon>
          Full Editor To Design Your Own
          <span class="u_nowrap"
            >Presentations
            <streamline-icon
              ariaLabel="More information"
              name="help"
              class="help"
              [outsideClick]="true"
              [popover]="'Don&rsquo;t want to use our templates? No problem, you can create your own presentations with our editor.'"
            >
            </streamline-icon
          ></span>
        </li>
        <li>
          <streamline-icon
            aria-hidden="true"
            name="checkmark"
            class="checkmark"
          ></streamline-icon>
          Scheduling &amp;
          <span class="u_nowrap"
            >Playlists
            <streamline-icon
              ariaLabel="More information"
              name="help"
              class="help"
              [outsideClick]="true"
              [popover]="'Show the content you want at the time you want with easy customizable schedules and playlists.'"
            >
            </streamline-icon
          ></span>
        </li>
        <li>
          <streamline-icon
            aria-hidden="true"
            name="checkmark"
            class="checkmark"
          ></streamline-icon>
          Support Replies Within A Business
          <span class="u_nowrap"
            >Hour
            <streamline-icon
              ariaLabel="More information"
              name="help"
              class="help"
              [outsideClick]="true"
              [popover]="'Fast and helpful customer support within a business hour.'"
            >
            </streamline-icon
          ></span>
        </li>
        <li class="border-top tw-mt-8 !tw-p-0">
          <div class="tw-flex tw-flex-col tw-justify-center tw-pt-4">
            <div class="tw-flex tw-flex-row tw-items-center tw-gap-2 tw-mb-2">
              <mat-icon
                svgIcon="ai-chatbot-feature"
                class="large ai-chatbot-feature-icon"
                aria-hidden="true"
              ></mat-icon>
              <strong>AI Credits Included:</strong>
            </div>
            <div
              class="tw-flex tw-flex-col tw-justify-center tw-gap-2 tw-pl-12"
            >
              <span>10 Credits</span>
              <span>+1 Credit per Basic License</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div
      id="plan-2-features"
      class="feature-list bottom-grid-row"
      [ngClass]="{ selected: isAdvancedPlan && !isUnlimitedPlan }"
    >
      <ul>
        <li class="mt-3 mb-2"><strong>Everything In Basic, Plus:</strong></li>
        <li>
          <streamline-icon
            aria-hidden="true"
            name="checkmark"
            class="checkmark"
          ></streamline-icon>
          Emergency Alerts From A Service That Supports CAP (Common Alerting
          <span class="u_nowrap"
            >Protocol)
            <streamline-icon
              ariaLabel="More information"
              name="help"
              class="help"
              [outsideClick]="true"
              [popover]="'Receive emergency alerts from any service that supports CAP (Common Alerting Protocol), such as Singlewire, Punch Alert, E2Campus, Rave, Alertus, CrisisGo, and configure those alerts to immediately show on any or all of your active displays.'"
            >
            </streamline-icon
          ></span>
        </li>
        <li>
          <streamline-icon
            aria-hidden="true"
            name="checkmark"
            class="checkmark"
          ></streamline-icon>
          Get Notified When Your Display Goes
          <span class="u_nowrap"
            >Offline
            <streamline-icon
              ariaLabel="More information"
              name="help"
              class="help"
              [outsideClick]="true"
              [popover]="'Continuously monitor the status of your display and receive an email notification if your display goes offline.'"
            >
            </streamline-icon
          ></span>
        </li>
        <li>
          <streamline-icon
            aria-hidden="true"
            name="checkmark"
            class="checkmark"
          ></streamline-icon>
          {{
            canAccessUnlimitedPlan
              ? 'School Wide Scheduling'
              : 'Scheduling Overrides In'
          }}
          <span class="u_nowrap">
            {{ canAccessUnlimitedPlan ? 'Overrides' : 'Company' }}
            <streamline-icon
              ariaLabel="More information"
              name="help"
              class="help"
              [outsideClick]="true"
              popover="Show priority messages on all displays in your {{
                canAccessUnlimitedPlan ? 'school' : 'company'
              }} either immediately or as part of your regularly scheduled content."
            >
            </streamline-icon
          ></span>
        </li>
        <li>
          <streamline-icon
            aria-hidden="true"
            name="checkmark"
            class="checkmark"
          ></streamline-icon>
          Set Brand Logo &amp; Colors Once, Apply To All
          <span class="u_nowrap"
            >Content
            <streamline-icon
              ariaLabel="More information"
              name="help"
              class="help"
              [outsideClick]="true"
              [popover]="'Automatically add your logo and colors to all of your Templates saving you time and helping you maintain a consistent look.'"
            >
            </streamline-icon
          ></span>
        </li>
        <li>
          <streamline-icon
            aria-hidden="true"
            name="checkmark"
            class="checkmark"
          ></streamline-icon>
          Display
          <span class="u_nowrap"
            >Control
            <streamline-icon
              ariaLabel="More information"
              name="help"
              class="help"
              [outsideClick]="true"
              [popover]="'Automatically turn your display on or off according to the schedule it is assigned to allowing you to conserve electrical usage and extend the life of your hardware.'"
            >
            </streamline-icon
          ></span>
        </li>
        <li>
          <streamline-icon
            aria-hidden="true"
            name="checkmark"
            class="checkmark"
          ></streamline-icon>
          Stock Image &amp; Video
          <span class="u_nowrap"
            >Library
            <streamline-icon
              ariaLabel="More information"
              name="help"
              class="help"
              [outsideClick]="true"
              [popover]="'Use images and videos from a stock library to enhance the design of any presentation.'"
            >
            </streamline-icon
          ></span>
        </li>
        <li>
          <streamline-icon
            aria-hidden="true"
            name="checkmark"
            class="checkmark"
          ></streamline-icon>
          Meta Integrations (Facebook &amp;
          <span class="u_nowrap"
            >Instagram)
            <streamline-icon
              ariaLabel="More information"
              name="help"
              class="help"
              [outsideClick]="true"
              [popover]="'Easily showcase Facebook and Instagram posts, along with real-time follower counts for your pages.'"
            >
            </streamline-icon
          ></span>
        </li>
        <li>
          <streamline-icon
            aria-hidden="true"
            name="checkmark"
            class="checkmark"
          ></streamline-icon>
          Google Sheets List
          <span class="u_nowrap"
            >Component
            <streamline-icon
              ariaLabel="More information"
              name="help"
              class="help"
              [outsideClick]="true"
              [popover]="'Link data from your Google Sheet to automatically update on your Display.'"
            >
            </streamline-icon
          ></span>
        </li>
        <li class="border-top tw-mt-8 !tw-p-0">
          <div class="tw-flex tw-flex-col tw-justify-center tw-pt-4">
            <div class="tw-flex tw-flex-row tw-items-center tw-gap-2 tw-mb-2">
              <mat-icon
                svgIcon="ai-chatbot-feature"
                class="large ai-chatbot-feature-icon"
                aria-hidden="true"
              ></mat-icon>
              <strong>AI Credits Included:</strong>
            </div>
            <div
              class="tw-flex tw-flex-col tw-justify-center tw-gap-2 tw-pl-12"
            >
              <span>15 Credits</span>
              <span>+1 Credit per Advanced License</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div
      id="plan-3-features"
      class="feature-list bottom-grid-row"
      [ngClass]="{ selected: isUnlimitedPlan || isEnterprisePlan }"
    >
      <ul>
        <li class="mt-3 mb-2">
          <strong>Everything In Advanced, Plus:</strong>
        </li>
        <li [shown]="canAccessUnlimitedPlan">
          <streamline-icon
            aria-hidden="true"
            name="checkmark"
            class="checkmark"
          ></streamline-icon>
          Unlimited Displays (with Unlimited
          <span class="u_nowrap"
            >plan)
            <streamline-icon
              ariaLabel="More information"
              name="help"
              class="help"
              [outsideClick]="true"
              [popover]="'Show content on every display in your school for a fixed price.'"
            >
            </streamline-icon
          ></span>
        </li>
        <li>
          <streamline-icon
            aria-hidden="true"
            name="checkmark"
            class="checkmark"
          ></streamline-icon>
          {{ canAccessUnlimitedPlan ? 'Classroom' : 'Automatic Alerts' }}
          <span class="u_nowrap">
            {{ canAccessUnlimitedPlan ? 'Alerts' : 'Overrides' }}
            <streamline-icon
              ariaLabel="More information"
              name="help"
              class="help"
              [outsideClick]="true"
              [popover]="'Show emergency alerts or announcements on any display in your network regardless of whether it is currently showing a Rise Vision presentation.'"
            >
            </streamline-icon
          ></span>
        </li>
        <li [shown]="canAccessUnlimitedPlan">
          <streamline-icon
            aria-hidden="true"
            name="checkmark"
            class="checkmark"
          ></streamline-icon>
          Teacher Specific User
          <span class="u_nowrap"
            >Role
            <streamline-icon
              ariaLabel="More information"
              name="help"
              class="help"
              [outsideClick]="true"
              [popover]="'Assign displays to your teachers allowing them to manage their content in a simple interface.'"
            >
            </streamline-icon
          ></span>
        </li>
        <li>
          <streamline-icon
            aria-hidden="true"
            name="checkmark"
            class="checkmark"
          ></streamline-icon>
          {{
            canAccessUnlimitedPlan
              ? 'District Wide Scheduling'
              : 'Scheduling Overrides In'
          }}
          <span class="u_nowrap">
            {{ canAccessUnlimitedPlan ? 'Overrides' : 'Sub-Companies' }}
            <streamline-icon
              ariaLabel="More information"
              name="help"
              class="help"
              [outsideClick]="true"
              popover="Show priority messages on all displays in all {{
                canAccessUnlimitedPlan ? 'schools' : 'companies'
              }} throughout your {{
                canAccessUnlimitedPlan ? 'district' : 'network'
              }} either immediately or as part of your regularly scheduled content."
            >
            </streamline-icon
          ></span>
        </li>
        <li>
          <streamline-icon
            aria-hidden="true"
            name="checkmark"
            class="checkmark"
          ></streamline-icon>
          Share Custom Templates
          {{ canAccessUnlimitedPlan ? 'Throughout' : 'With' }} Your
          <span class="u_nowrap">
            {{ canAccessUnlimitedPlan ? 'District' : 'Organization' }}
            <streamline-icon
              ariaLabel="More information"
              name="help"
              class="help"
              [outsideClick]="true"
              popover="Save custom presentations as templates and share them throughout your {{
                canAccessUnlimitedPlan ? 'district' : 'network'
              }}."
            >
            </streamline-icon
          ></span>
        </li>
        <li>
          <streamline-icon
            aria-hidden="true"
            name="checkmark"
            class="checkmark"
          ></streamline-icon>
          Microsoft Power
          <span class="u_nowrap"
            >BI
            <streamline-icon
              ariaLabel="More information"
              name="help"
              class="help"
              [outsideClick]="true"
              [popover]="'Securely show any of your Power BI Dashboards on your display.'"
            >
            </streamline-icon>
          </span>
        </li>
        <li>
          <streamline-icon
            aria-hidden="true"
            name="checkmark"
            class="checkmark"
          ></streamline-icon>
          Single Sign On
          <span class="u_nowrap"
            >(SSO)
            <streamline-icon
              ariaLabel="More information"
              name="help"
              class="help"
              [outsideClick]="true"
              [popover]="'User authentication with Google, Microsoft or ClassLink for added security.'"
            >
            </streamline-icon>
          </span>
        </li>
        <li>
          <streamline-icon
            aria-hidden="true"
            name="checkmark"
            class="checkmark"
          ></streamline-icon>
          Enterprise License
          <span class="u_nowrap"
            >Management
            <streamline-icon
              ariaLabel="More information"
              name="help"
              class="help"
              [outsideClick]="true"
              popover="You can manage your licenses at the {{
                canAccessUnlimitedPlan ? 'district' : 'parent'
              }} level allowing you to purchase and assign enterprise {{
                canAccessUnlimitedPlan
                  ? 'or unlimited licenses for all your schools'
                  : 'licenses throughout your organization'
              }}."
            >
            </streamline-icon>
          </span>
        </li>
        <li>
          <streamline-icon
            aria-hidden="true"
            name="checkmark"
            class="checkmark"
          ></streamline-icon>
          Screen
          <span class="u_nowrap"
            >Sharing
            <streamline-icon
              ariaLabel="More information"
              name="help"
              class="help"
              [outsideClick]="true"
              [popover]="'Screen sharing transforms any Rise Vision display into a wireless presentation hub. Easily share to your screens without needing an account, or opt for secure, moderated sessions with full control.'"
            >
            </streamline-icon
          ></span>
        </li>
        <li>
          <streamline-icon
            aria-hidden="true"
            name="checkmark"
            class="checkmark"
          ></streamline-icon>
          Content Publishing
          <span class="u_nowrap"
            >Approval
            <streamline-icon
              ariaLabel="More information"
              name="help"
              class="help"
              [outsideClick]="true"
              [popover]="'A formal approval process where Content Publishers will be notified to review the content created by Content Editors so that it can be approved and published.'"
            >
            </streamline-icon
          ></span>
        </li>
        <!-- <li>
          <streamline-icon aria-hidden="true" name="checkmark" class="checkmark"></streamline-icon>
          Bulk Actions For Presentations, Users, Displays, Schedules, &amp; <span class="u_nowrap">{{ canAccessUnlimitedPlan ? 'Schools' : 'Companies' }}
          <streamline-icon
            ariaLabel="More information"
            name="help"
            class="help"
            [outsideClick]="true"
            popover="Move, import and export multiple presentations, schedules, displays, users or {{ canAccessUnlimitedPlan ? 'schools' : 'companies' }} with ease.">
          </streamline-icon></span>
        </li> -->
        <li class="border-top tw-mt-8 !tw-p-0">
          <div class="tw-flex tw-flex-col tw-justify-center tw-pt-4">
            <div class="tw-flex tw-flex-row tw-items-center tw-gap-2 tw-mb-2">
              <mat-icon
                svgIcon="ai-chatbot-feature"
                class="large ai-chatbot-feature-icon"
                aria-hidden="true"
              ></mat-icon>
              <strong>Enterprise AI Credits Included:</strong>
            </div>
            <div
              class="tw-flex tw-flex-col tw-justify-center tw-gap-2 tw-pl-12"
            >
              <span>30 Credits</span>
              <span>+1 Credit per Enterprise License</span>
            </div>
          </div>
        </li>
        <li class="!tw-p-0" [shown]="canAccessUnlimitedPlan">
          <div class="tw-flex tw-flex-col tw-justify-center">
            <div
              class="tw-flex tw-flex-row tw-items-center tw-gap-2 tw-pl-12 tw-mb-2"
            >
              <strong>Unlimited AI Credits Included:</strong>
            </div>
            <div
              class="tw-flex tw-flex-col tw-justify-center tw-gap-2 tw-pl-12"
            >
              <span>40 Credits per Unlimited License</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div id="plan-spacer-1" class="spacer">&nbsp;</div>
    <div id="plan-spacer-2" class="spacer">&nbsp;</div>
    <div id="plan-spacer-3" class="spacer">&nbsp;</div>
  </div>
</div>
@if (!subscriptionId) {
  <expandable-panel class="tw-my-[44px]">
    <ng-container expandable-panel-title
      ><h3 class="tw-font-semibold tw-m-0">
        Boost your Plan with Add-ons
      </h3></ng-container
    >
    <ng-container expandable-panel-content>
      <p class="tw-text-gray-600">
        Enhance your digital signage with interactive features and AI-powered
        content generation.
      </p>
      <p class="tw-text-blue-600 tw-font-medium">
        + Select the add-ons you’d like to add.
      </p>
      <div class="add-on-cards">
        <div class="add-on-card">
          <div class="add-on-card__section">
            <div class="add-on-card__icon-wrap">
              <mat-icon
                class="add-on-card__mat-icon add-on-card__mat-icon--interactive"
                svgIcon="cursor-hand"
                aria-hidden="true"
              ></mat-icon>
            </div>
          </div>
          <div class="add-on-card__section">
            <h4 class="add-on-card__title">Interactive Licenses</h4>
            <p class="add-on-card__description">
              Enable touch-screen displays and templates.
            </p>
            <ul class="feature-list add-on-card__feature-list">
              <li>
                <streamline-icon
                  aria-hidden="true"
                  name="checkmark"
                  [height]="16"
                  [width]="16"
                  class="checkmark"
                ></streamline-icon>
                Includes ready built templates
              </li>
              <li>
                <streamline-icon
                  aria-hidden="true"
                  name="checkmark"
                  class="checkmark"
                ></streamline-icon>
                Portrait &amp; Landscape Support
              </li>
              <li>
                <streamline-icon
                  aria-hidden="true"
                  name="checkmark"
                  class="checkmark"
                ></streamline-icon>
                Manage and update content remotely, from anywhere
              </li>
            </ul>
          </div>
          <div class="add-on-card__section">
            <label class="add-on-card__label"
              >Number of interactive licenses</label
            >
            <div
              class="add-on-card__quantity-wrap"
              [matTooltipDisabled]="!periodMonthly"
              matTooltipClass="menu-tooltip"
              [matTooltip]="'Available with annual plans.'"
            >
              <rv-quantity
                name="interactiveLicensesCount"
                [ngModel]="interactiveLicensesCount"
                (ngModelChange)="onInteractiveQuantityChange($event)"
                [disabled]="periodMonthly"
                [min]="0"
                ariaLabel="Number of interactive licenses"
              ></rv-quantity>
            </div>
          </div>
        </div>
        <div class="add-on-card">
          <div class="add-on-card__section">
            <div class="add-on-card__icon-wrap">
              <mat-icon
                class="filled add-on-card__mat-icon add-on-card__mat-icon--ai"
                svgIcon="ai"
                aria-hidden="true"
              ></mat-icon>
            </div>
          </div>
          <div class="add-on-card__section">
            <h4 class="add-on-card__title">AI Credits</h4>
            <p class="add-on-card__description">Get more credits each month.</p>
            <ul class="feature-list add-on-card__feature-list">
              <li>
                <streamline-icon
                  aria-hidden="true"
                  name="checkmark"
                  class="checkmark"
                ></streamline-icon>
                Instant template &amp; copy generation
              </li>
              <li>
                <streamline-icon
                  aria-hidden="true"
                  name="checkmark"
                  class="checkmark"
                ></streamline-icon>
                AI-powered image search &amp; creation
              </li>
              <li>
                <streamline-icon
                  aria-hidden="true"
                  name="checkmark"
                  class="checkmark"
                ></streamline-icon>
                Smart translation to 20+ languages
              </li>
            </ul>
          </div>
          <div class="add-on-card__section">
            <label class="add-on-card__label">AI Credits per month</label>
            <div
              class="add-on-card__quantity-wrap"
              [matTooltipDisabled]="!periodMonthly"
              matTooltipClass="menu-tooltip"
              [matTooltip]="'Available with annual plans.'"
            >
              <rv-quantity
                name="aiCreditsPerMonth"
                [enforceStep]="true"
                [step]="50"
                [ngModel]="aiCreditsPerMonth()"
                (ngModelChange)="onAiCreditsQuantityChange($event)"
                [disabled]="periodMonthly"
                [min]="0"
                ariaLabel="AI Credits per month"
              ></rv-quantity>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </expandable-panel>
}
<div
  id="summary-container"
  class="border-container madero-style w-100 mx-0 p-5 mb-5"
>
  <div
    class="pricing-summary__note mx-2 px-0 mx-md-3 px-md-3 mx-lg-5 px-lg-5"
    [shown]="isUnlimitedPlan"
  >
    <p class="pricing-summary__note-text mb-0">
      <span class="font-weight-bold">Note:</span>
      An unlimited license is a site license per school building. If purchasing
      for a school district or network of schools, you need to purchase a
      separate license for each school. If you have any questions, our
      <a
        class="pricing-summary__sales-link"
        href="https://www.risevision.com/contact-us?form_selected=sales&content_hide=true"
        target="_blank"
        rel="noopener noreferrer"
        >Sales Team</a
      >
      is happy to help!
    </p>
  </div>

  <div class="pricing-summary__heading">
    <p class="pricing-summary__title mb-0">Pricing</p>
  </div>

  <div class="pricing-summary__lines">
    @if (isUnlimitedPlan) {
      <div class="pricing-summary__row">
        <div class="pricing-summary__label-container">
          <div class="pricing-summary__label">
            <span class="pricing-summary__qty">{{ unlimitedCount }}</span>
            <span class="pricing-summary__multiply" aria-hidden="true"
              >&times;</span
            >
            <span class="pricing-summary__kind">Unlimited Licenses</span>
          </div>
          <div class="pricing-summary__detail">
            ${{ unlimitedPrice | number: '1.0-0' }} per year, billed annually
          </div>
        </div>
        <div class="pricing-summary__amount">
          <span class="pricing-summary__value"
            >${{ unlimitedTotal | number: '1.0-0' }}</span
          >
        </div>
      </div>
    }
    @if (isPerDisplayPlan) {
      <div class="pricing-summary__row">
        <div class="pricing-summary__label-container">
          <div class="pricing-summary__label">
            <span class="pricing-summary__qty">{{ displayCount }}</span>
            <span class="pricing-summary__multiply" aria-hidden="true"
              >&times;</span
            >
            <span class="pricing-summary__kind">Display Licenses</span>
          </div>
          <div class="pricing-summary__detail">
            @if (pricePerDisplay === baseDisplayPrice) {
              <span class="pricing-summary__unit-line">
                ${{ baseDisplayPrice | number: '1.0-0' }}&nbsp;per display, per
                {{ periodMonthly && isBasicPlan ? 'month' : 'year' }}
              </span>
            } @else {
              <span class="pricing-summary__unit-line">
                <del>${{ baseDisplayPrice | number: '1.0-0' }}</del
                >&nbsp; ${{ pricePerDisplay | number: '1.0-0' }}&nbsp;per
                display, per
                {{ periodMonthly && isBasicPlan ? 'month' : 'year' }}
              </span>
            }
            @if (yearlySavings > 0) {
              <span class="label label-primary pricing-summary__savings"
                >save ${{ yearlySavings | number: '1.0-0' }}!</span
              >
            }
          </div>
        </div>
        <div class="pricing-summary__amount">
          <span class="pricing-summary__value"
            >${{ displayTotal | number: '1.0-0' }}</span
          >
        </div>
      </div>
    }
    @if (hasInteractiveLicenses) {
      <div class="pricing-summary__row">
        <div class="pricing-summary__label-container">
          <div class="pricing-summary__label">
            <span class="pricing-summary__qty">{{
              interactiveLicensesCount
            }}</span>
            <span class="pricing-summary__multiply" aria-hidden="true"
              >&times;</span
            >
            <span class="pricing-summary__kind">Interactive Licenses</span>
          </div>
          <div class="pricing-summary__detail">
            <span class="pricing-summary__unit-line">
              ${{
                (interactiveEstimateAmount() ?? 0) / interactiveLicensesCount
                  | number: '1.0-0'
              }}
              per license, per year
            </span>
          </div>
        </div>
        <div
          class="pricing-summary__amount"
          [attr.aria-busy]="interactiveEstimateLoading() ? 'true' : null"
        >
          @if (interactiveEstimateLoading()) {
            <rv-skeleton
              class="pricing-summary__skeleton"
              aria-label="Loading Interactive estimate"
            />
          } @else if (
            !interactiveEstimateError() && interactiveEstimateAmount() !== null
          ) {
            <span class="pricing-summary__value">
              ${{ interactiveEstimateAmount() | number: '1.0-0' }}</span
            >
          } @else {
            <span class="pricing-summary__value"
              >${{ 0 | number: '1.0-0' }}</span
            >
          }
        </div>
      </div>
    }
    @if (hasAiCreditsPerMonth()) {
      <div class="pricing-summary__row">
        <div class="pricing-summary__label-container">
          <div class="pricing-summary__label">
            <span class="pricing-summary__qty">{{ aiCreditsPerMonth() }}</span>
            <span class="pricing-summary__kind">credits a month</span>
          </div>
        </div>
        <div
          class="pricing-summary__amount"
          [attr.aria-busy]="aiCreditsEstimateLoading() ? 'true' : null"
        >
          @if (aiCreditsEstimateLoading()) {
            <rv-skeleton
              class="pricing-summary__skeleton"
              aria-label="Loading AI Credits estimate"
            />
          } @else if (
            !aiCreditsEstimateError() && aiCreditsEstimateAmount() !== null
          ) {
            <span class="pricing-summary__value"
              >${{ aiCreditsEstimateAmount() | number: '1.0-0' }}</span
            >
          } @else {
            <span class="pricing-summary__value"
              >${{ 0 | number: '1.0-0' }}</span
            >
          }
        </div>
      </div>
    }
  </div>

  <rv-divider class="pricing-summary__divider"></rv-divider>

  <div class="pricing-summary__row pricing-summary__row--total">
    <div class="pricing-summary__total-left">
      <span class="pricing-summary__total-heading">Total</span>
      @if (periodMonthly && isBasicPlan) {
        <span class="pricing-summary__billed-label">(Billed monthly)</span>
      } @else {
        <span class="pricing-summary__billed-label">(Billed annually)</span>
      }
    </div>
    <div
      class="pricing-summary__amount pricing-summary__amount--total"
      [attr.aria-busy]="
        interactiveEstimateLoading() || aiCreditsEstimateLoading()
          ? 'true'
          : null
      "
    >
      @if (interactiveEstimateLoading() || aiCreditsEstimateLoading()) {
        <rv-skeleton
          class="pricing-summary__skeleton"
          aria-label="Loading total estimate"
        />
      } @else {
        <span class="pricing-summary__value pricing-summary__value--total"
          >${{ totalPrice() | number: '1.0-0' }}</span
        >
      }
    </div>
  </div>
</div>
